import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import classNames from "classnames";
import { sendMetriks } from "Services/sendMetriks";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "center",
	},
	ButtonBox: {
		// width: "180px",
		height: "50px",
		cursor: "pointer",
	},
	textButton: {
		width: "auto",
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		color: theme.palette.colors.purplishBlue,
		letterSpacing: 2,
	},
	band: {
		width: "auto",
		height: "2px",
		backgroundColor: theme.palette.colors.purplishBlue,
	},
	margin: {
		marginLeft: "50px",
	},

	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {},
	[`@media (max-width: ${theme.media.sm})`]: {
		textButton: {
			fontSize: "12px",
		},
		margin: {
			marginLeft: "30px",
		},
	},
}));

const ToogleRatesMobile = (props) => {
	const { commonViewModel, page, text, mobileTariffsMode } = props;

	const classes = useStyles();

	return (
		<div className={classes.root}>
			{!mobileTariffsMode.includes("only") ? (
				<div
					onClick={() => {
						commonViewModel.setRatesMobilePage("antifilter");
						sendMetriks("CLICK_CONSTRUCTOR");
					}}
					className={classes.ButtonBox}
				>
					<div className={classes.textButton}>{text.CONSTRUCTOR_NEW}</div>
					{page === "antifilter" && <div className={classes.band}></div>}
				</div>
			) : null}

			{!mobileTariffsMode.includes("only") ? (
				<div
					onClick={() => {
						commonViewModel.setRatesMobilePage("list");
						sendMetriks("CLICK_SPISOK");
					}}
					className={classNames(classes.ButtonBox, classes.margin)}
				>
					<div className={classes.textButton}>
						{text.LIST_TARIFFS}
						{page === "list" && <div className={classes.band}></div>}
					</div>
				</div>
			) : null}
		</div>
	);
};

ToogleRatesMobile.propTypes = {
	mobileTariffsMode: PropTypes.string.isRequired,
	page: PropTypes.string.isRequired,
	text: PropTypes.object.isRequired,
	commonViewModel: PropTypes.object.isRequired,
};

export default ToogleRatesMobile;
